"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function addDefaultPropertiesForPeerGradable(content, toUpdateObject) {
    if (content.content.gradingScheme === 'peerGradable') {
        return Object.assign({}, toUpdateObject, { reviewsReceivedCount: 0 });
    }
    return toUpdateObject;
}
exports.default = addDefaultPropertiesForPeerGradable;
//# sourceMappingURL=addDefaultPropertiesForPeerGradable.js.map